import {
  FreeZonePlateValue,
  InputNames,
} from '@/common/components/base/input/plate/freeZonePlateInput/freeZonePlateInput.type';
import { UseControllerProps } from 'react-hook-form';

export const freeZonePlateRules: Record<
  InputNames,
  UseControllerProps['rules']
> = {
  vehicle_plate_top: { required: true, min: 11, max: 99 },
  vehicle_plate_bottom: { required: true, min: 111, max: 999 },
};

export const FreePlateEmptyRules = (
  value: FreeZonePlateValue,
  isMotorFreeZone: boolean,
) => {
  const { plate } = value;

  const validations = isMotorFreeZone
    ? [{ field: plate.vehicle_plate_bottom, minLength: 5, maxLength: 5 }]
    : [
        { field: plate.vehicle_plate_bottom, minLength: 5, maxLength: 5 },
        { field: plate.vehicle_plate_top, minLength: 2, maxLength: null },
      ];

  const isValid = validations.every(({ field, minLength, maxLength }) => {
    if (!field) return false;
    const length = field.toString().length;
    return length >= minLength && (maxLength === null || length === maxLength);
  });

  return isValid || 'پلاک را کامل وارد کنید';
};
